import React from "react";
import classes from "./formCheckBoxChip.module.css"

export const FormCheckboxChips = ({
  id,
  label,
  options = [],
  register,
  watch,
  setValue,
  disabled,
}) => {
  // Get the current value from React Hook Form
  const value = watch(id); // <-- use watch

  const handleClick = (opt) => {
    if (disabled) return;
    // toggle value
    setValue(id, value === opt.id ? "" : opt.id);
  };

  return (
    <div className={classes.container}>
      {label && <span className={classes.label}>{label}</span>}
      <div className={classes.chipsWrapper}>
        {options.map((opt) => (
          <span
            key={opt.id}
            className={`${classes.chip} ${value === opt.id ? classes.active : ""} ${
              disabled ? classes.disabled : ""
            }`}
            onClick={() => handleClick(opt)}
          >
            {opt.label}
          </span>
        ))}
      </div>
      <input type="hidden" {...register(id)} /> {/* still needed */}
    </div>
  );
};
